import produce from 'immer';

import { GET_TRANSACTION_LIST_FAILURE, GET_TRANSACTION_LIST_SUCCESS } from '@actions/transaction';

const initialState: ITransactionStore = {
  transactionsList: null,
  error: null,
};

export default (state: ITransactionStore = initialState, action: any) =>
  produce(state, (draftState: ITransactionStore) => {
    switch (action.type) {
      case GET_TRANSACTION_LIST_SUCCESS:
        draftState.transactionsList = action.response;
        draftState.error = null;

        return;

      case GET_TRANSACTION_LIST_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
